import Svg, { Path } from 'react-native-svg';

const ASPECT = 24.0361 / 27.9998; // Figma viewBox

/**
 * The Tabbio "t" monogram outline (the Subtract path from Figma), in a
 * `0 0 24.0361 27.9998` viewBox. Exported so the QR-center logo: which needs a
 * raw SVG string / data-URI rather than a React element: shares this single
 * source of truth instead of re-pasting the path.
 */
export const TABBIO_MARK_PATH =
  'M5.05762 0.0242382C8.24806 -0.0283878 11.5976 0.0210352 14.8027 0.0213085C14.7806 1.07161 14.8009 2.19575 14.8008 3.2508L14.7998 9.52326L21.5635 9.52619L21.5596 14.9774L14.8018 14.9754L14.7998 22.5067L24.0361 22.5096L24.0342 26.2781L24.0322 27.9979L17.8818 27.9998C15.2273 27.9971 13.0641 27.6624 11.0742 25.6922C9.10929 23.7465 9.30806 21.8741 9.30957 19.3055L9.31348 14.9744L0.000976562 14.9754L0 5.05842C1.68873 3.43561 3.35518 1.61203 5.05762 0.0242382ZM5.71582 5.82111L2.00977 5.81818V9.52424L5.62207 9.52521L9.31055 9.52717L9.31348 1.95197L5.71973 1.951L5.71582 5.82111Z';

/**
 * Tabbio "t" monogram (the Subtract path from Figma).
 * Cross-platform (react-native-svg renders on iOS/Android/web).
 * `color` defaults to white: the welcome top bar sits on the violet gradient.
 */
export function TabbioMark({
  size = 28,
  color = '#ffffff',
}: {
  size?: number;
  color?: string;
}) {
  return (
    <Svg width={size * ASPECT} height={size} viewBox="0 0 24.0361 27.9998" fill="none">
      <Path d={TABBIO_MARK_PATH} fill={color} />
    </Svg>
  );
}
